import { ApolloClient, ApolloProvider, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/link-context';
import React, { useMemo } from 'react';
import { useSession } from 'next-auth/react';

const apolloClient = new ApolloClient({
  link: undefined,
  cache: new InMemoryCache(),
  connectToDevTools: true,
});

const AuthorizedApolloProvider = ({ children, ...props }: any) => {
  const { data: session } = useSession();
  const token = session?.accessToken;
  const httpLink = createHttpLink({
    uri: props.apiUrl,
  });

  if (token) {
    const authLink = setContext(() => ({
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }));
    apolloClient.setLink(authLink.concat(httpLink));
  }

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};

export default AuthorizedApolloProvider;
